<template>
    <div class="single-item-pd">
        <div class="row align-items-center">
            <div class="col-xl-9">
                <div class="single-features-item single-features-item-df b-radius mb-20">
                    <div class="row  g-0 align-items-center">
                        <div class="col-md-4">
                            <div class="features-thum">
                                <div class="features-product-image w-img">
                                    <router-link :to="`/shop-details/${product.id}`">
                                        <img :src="product.image" alt="" class="shop-thumb-img">
                                    </router-link>
                                </div>
                                <div class="product__offer" v-if="product.discount_percentage">
                                    <span class="discount">-{{ product.discount_percentage }}%</span>
                                </div>
                                <div class="product-action">
                                    <a href="#" class="icon-box icon-box-1" data-bs-toggle="modal"
                                        @click.prevent="handleOpenModal(product)">
                                        <i class="fas fa-eye"></i>
                                        <i class="fas fa-eye"></i>
                                    </a>
                                    <a
                                        href="#"
                                        class="icon-box icon-box-1"
                                        :class="{ active: isItemInWishlist(product) }"
                                        @click.prevent="toggleWishlist(product)"
                                    >
                                        <i class="fas fa-heart"></i>
                                    </a>
                                    <!-- <a href="#" class="icon-box icon-box-1">
                                        <i class="fas fa-layer-group"></i>
                                        <i class="fas fa-layer-group"></i>
                                    </a> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="product__content product__content-d">
                                <h6><router-link :to="`/product-details/${product.id}`">{{ product.title }}</router-link>
                                </h6>
                                <!--  <div class="rating mb-5">
                                    <ul class="rating-d">
                                        <li><a href="#"><i class="fal fa-star"></i></a></li>
                                        <li><a href="#"><i class="fal fa-star"></i></a></li>
                                        <li><a href="#"><i class="fal fa-star"></i></a></li>
                                        <li><a href="#"><i class="fal fa-star"></i></a></li>
                                        <li><a href="#"><i class="fal fa-star"></i></a></li>
                                    </ul>
                                    <span>({{ product.reviews.length }} review)</span>
                                </div> -->
                                <div class="features-des">
                                    <ul>
                                        <li v-for="(list, i) in product.feature_lists" :key="i"><a href="#"><i
                                                    class="fas fa-circle"></i>{{ list }}</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3">
                <div class="product-stock mb-15">
                    <h5>Availability: <span> {{ product.quantity }} in stock</span></h5>
                    <h6>LKR {{ product.price }} - <del>
                            LKR {{ calculateOriginalPrice(product.price, product.discount_percentage).toFixed(2) }}</del>
                    </h6>
                </div>
                <div class="stock-btn ">
                    <button v-if="!isItemInCart(product)"  @click="addToCart(product)" type="button"
                        class="cart-btn d-flex mb-10 align-items-center justify-content-center w-100">
                        Add to Cart
                    </button>
                    <!-- <router-link to="/cart" v-if="isItemInCart(product)"
                        class="cart-btn d-flex mb-10 align-items-center justify-content-center w-100">
                        View Cart
                    </router-link>
                    <button type="button" class="wc-checkout d-flex align-items-center justify-content-center w-100"
                        data-bs-toggle="modal" @click.prevent="handleOpenModal(product)">
                        Quick View
                    </button> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { useCartStore } from "@/stores/useCartStore"
import { useWishlistStore } from '@/stores/wishlistStore'
// eslint-disable-next-line no-unused-vars
import { calculateOriginalPrice } from "@/utils/utils"

export default {
    name: "SingleItem",
    props: {
        product: {
            type: Object,
            required: true,
        },
    },
    data() {
        // Access the Pinia store using `useCartStore()`
        return {
            cartStore: useCartStore(),
            wishlistStore: useWishlistStore(),
        }
    },
    methods: {

        isItemInCart(product) {
            // Return true if the product exists in the cart
            return this.cartStore.cart_products.some((prd) => prd.id === product.id)
        },
        // Add a product to the cart
        addToCart(product) {
            this.cartStore.addCartProduct(product)
        },

        isItemInWishlist(product) {
            return this.wishlistStore.wishlists.some((prd) => String(prd.id) === String(product.id))
        },
        toggleWishlist(product) {
            this.wishlistStore.add_wishlist_product(product)
        },
        handleOpenModal() {},

        // Calculate original price before discount
        calculateOriginalPrice(price, discountPercentage) {
            return price / (1 - discountPercentage / 100)
        },
    },
}
</script>
<style scoped>
.features-product-image {
    width: 221px;
    height: 220px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    overflow: hidden;
}

.features-product-image a {
    width: 221px;
    height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
}.shop-thumb-img {
    width: 221px;
    height: 220px;
    object-fit: contain;
    object-position: center;
}
</style>
